import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {
  DobryAgentBlogArticle,
  DobryAgentBlogTag,
  DobryAgentFacility,
  DobryAgentImageVariant
} from '../../../../shared/interface/dobry-agent-blog-article';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {AuthService} from '../../../../shared/services/auth.service';
import {environment} from "../../../../../environments/environment";
import {DobryAgentBlogService} from "../../../../shared/services/dobry-agent-blog.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-da-article-details-view',
  templateUrl: './da-article-details-view.component.html',
  styleUrls: ['./da-article-details-view.component.scss']
})
export class DaArticleDetailsViewComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() blogArticle: ReplaySubject<DobryAgentBlogArticle>;
  @Output() modifyClicked = new EventEmitter<void>();

  userPermissions: ReplaySubject<UserPermissions>;
  blogArticleObject?: DobryAgentBlogArticle;

  constructor(
    private auth: AuthService,
    private dobryAgentBlogService: DobryAgentBlogService,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.blogArticle
      .pipe(takeUntil(this.destroyed$))
      .subscribe((article: DobryAgentBlogArticle) => {
        this.blogArticleObject = article;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }


  getArticleImage(article?: DobryAgentBlogArticle): string | null {
    if (!article) {
      return null;
    }

    if (article.imagePath) {
      return this.buildPublicImageUrl(article.imagePath);
    }

    const variantPath = this.getImageVariantPath(article.imagesVariants, 'large')
      ?? this.getImageVariantPath(article.imagesVariants, 'medium')
      ?? this.getImageVariantPath(article.imagesVariants, 'original')
      ?? this.getImageVariantPath(article.imagesVariants, 'small');

    return this.buildPublicImageUrl(variantPath);
  }

  getFacilityImage(facility?: DobryAgentFacility | null): string | null {
    if (!facility) {
      return null;
    }

    if (facility.imagePath) {
      return this.buildPublicImageUrl(facility.imagePath);
    }

    const variantPath = this.getImageVariantPath(facility.imagesVariants, 'large')
      ?? this.getImageVariantPath(facility.imagesVariants, 'medium')
      ?? this.getImageVariantPath(facility.imagesVariants, 'original')
      ?? this.getImageVariantPath(facility.imagesVariants, 'small');

    return this.buildPublicImageUrl(variantPath);
  }

  private getImageVariantPath(
    variants?: DobryAgentImageVariant[],
    size?: string
  ): string | null {
    if (!variants?.length) {
      return null;
    }

    const variant = variants.find(item => item.size === size);

    return variant?.path ?? null;
  }

  private buildPublicImageUrl(path?: string | null): string | null {
    if (!path) {
      return null;
    }

    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }

    if (path.startsWith('/public/')) {
      return `${environment.dobryAgentUrl}${path}`;
    }

    if (path.startsWith('/')) {
      return `${environment.dobryAgentUrl}/public${path}`;
    }

    return `${environment.dobryAgentUrl}/public/${path}`;
  }


  readonly environment = environment;

  delete(dobryAgentBlogArticle: DobryAgentBlogArticle): void {
    this.dobryAgentBlogService
      .confirmDelete(dobryAgentBlogArticle)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (!deleted) {
          return;
        }

        this.router.navigate([
          '/blog-dobry-agent/artykuly'
        ]);
      });
  }

  deleteWeak(uuid: string): void {
    this.dobryAgentBlogService
      .confirmDeleteWeak(uuid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (!deleted) {
          return;
        }

        this.router.navigate([
          '/blog-dobry-agent/artykuly'
        ]);
      });
  }
}
